// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b67fbdf4","447":"cce9f344","622":"3ef9a94c","967":"08baeac8","977":"1bb12ded"}[chunkId] + ".chunk.js";
};